<template>
    <div class="ps-page--simple">
        <div class="ps-breadcrumb">
            <div class="container">
                <ul class="breadcrumb">
                 <li v-if="isEn==true"> <router-link  to="/products" >Products</router-link> </li>
                 <li v-if="isEn==false"> <router-link  to="/products" >Produits</router-link> </li>
                 <li v-if="isEn==true">Checkout</li>
                 <li v-if="isEn==false">Finaliser votre commande</li>
                </ul>
            </div>
        </div>
        <div class="ps-checkout ps-section--shopping">
            <div class="container">
                <div class="ps-section__header">
                    <h1 v-if="isEn==true">Checkout</h1>
                    <h1 v-if="isEn==false">Finaliser votre commande</h1>
                    <h4 style="color:red" v-if="isEn==true">Note : Please fill the form before you submit</h4>
                    <h4 style="color:red" v-if="isEn==false">Important : Svp remplissez le formulaire avant de soumettre</h4>
                </div>
                <div class="ps-section__content">
                    <form class="ps-form--checkout" action="do_action" method="post">
                        <div class="row">
                            <div class="col-xl-7 col-lg-8 col-md-12 col-sm-12  ">
                                <div class="ps-form__billing-info">

                            <div>
                                    <h3 v-if="isEn==true" class="ps-form__heading"> Recipient information</h3>
                                    <h3 v-if="isEn==false" class="ps-form__heading">Informations du destinataire</h3>
                                    <div class="row form-group">
                                        <div class="col">
                                        <label v-if="isEn==true" for="exampleFormControlSelect1">Select an existing recipient</label>
                                        <label v-if="isEn==false" for="exampleFormControlSelect1">Choisir un destinaire existant</label>
                                        <select class="form-control"  @change="onChange()" v-model="selected_recip" required>
                                            <option v-if="isEn==true" value="" >Select a recipient </option>
                                            <option v-if="isEn==false" value="" >Choisir un destinataire </option>
                                            <option  v-for="recipient in recipients" :key="recipient.id" v-bind:value="recipient">  {{recipient.full_name}} </option>
                                        </select>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label v-if="isEn==true">Company<sup></sup> </label>
                                        <label v-if="isEn==false">Compagnie<sup></sup> </label>

                                        <div class="form-group__content">
                                            <input class="form-control" type="text" v-model="new_recipient.company" maxlength="30">
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label v-if="isEn==true">Full name <sup>*</sup></label>
                                        <label v-if="isEn==false">Nom complet<sup>*</sup></label>

                                        <div class="form-group__content">
                                            <input class="form-control" type="text" v-model="new_recipient.full_name" required maxlength="32">
                                        </div>
                                    </div>

                                  <div class="form-row">
                                    <div class="form-group col-md-8">
                                      <label v-if="isEn==true">Contact number<sup>*</sup> </label>
                                      <label v-if="isEn==false">Numero de téléphone<sup>*</sup> </label>
                                      <div class="form-group__content">
                                        <input class="form-control" type="text" v-model="new_recipient.contact" required>
                                      </div>
                                    </div>

                                    <div class="form-group col-md-4 col-sm">
                                      <label v-if="isEn==true" >Select Phone Extension</label>
                                      <label v-if="isEn==false" >Numéro de poste</label>
                                      <div class="form-group__content">
                                        <input class="form-control" type="text" v-model="new_recipient.phoneext" required maxlength="20">
                                      </div>
                                    </div>
                                  </div>

                                    <div class="form-group">
                                      <div class="custom-form">
                                        <label v-if="isEn==true">Address<sup>*</sup> </label>
                                        <label v-if="isEn==false">Adresse<sup>*</sup></label>
                                      </div>
                                        <div class="form-group__content">
                                            <input class="form-control" type="text" v-model="new_recipient.address" required maxlength="46">
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label v-if="isEn==true">Address 2</label>
                                        <label v-if="isEn==false">Adresse 2</label>
                                        <div class="form-group__content">
                                            <input class="form-control" type="text" v-model="new_recipient.address2" maxlength="25">
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label>Email <sup>*</sup>
                                        </label>
                                        <div class="form-group__content">
                                            <input class="form-control" type="email" v-model="new_recipient.email" required>
                                        </div>
                                    </div>                                   

                                    <div class="form-group">
                                        <label v-if="isEn==true">City<sup>*</sup> </label>
                                        <label v-if="isEn==false">Ville<sup>*</sup> </label>

                                        <div class="form-group__content">
                                            <input class="form-control" type="text" v-model="new_recipient.city" required maxlength="30">
                                        </div>
                                    </div>

                                    <div class="row form-group">
                                        <div class="col">
                                        <label v-if="isEn==true" for="exampleFormControlSelect1">Select country<sup>*</sup></label>
                                         <label v-if="isEn==false" for="exampleFormControlSelect1">Choisir un pays<sup>*</sup></label>
                                        <select class="form-control"  @change="onCountrySelect(new_recipient.country)" v-model="new_recipient.country" required>
                                            <option v-if="isEn==true" value="" >Select a country</option>
                                            <option v-if="isEn==false" value="" >Choisir un pays</option>
                                            <option  v-for="country in countries" :key="country.code" v-bind:value="country.code" >  {{country.name}} </option>
                                        </select>
                                        </div>
                                    </div>

                                    <div class="row form-group">
                                        <div class="col">
                                        <label v-if="isEn==true" for="exampleFormControlSelect1">Select region<sup>*</sup></label>
                                        <label v-if="isEn==false" for="exampleFormControlSelect1">Choisir région<sup>*</sup></label>
                                        <select class="form-control" v-model="new_recipient.region" required>
                                            <option v-if="isEn==true" value="" >Select a region</option>
                                            <option v-if="isEn==false" value="" >Choisir région</option>
                                            <option  v-for="region in regions" :key="region.region" v-bind:value="region.name">  {{region.name}} </option>
                                        </select>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label v-if="isEn==true">Postal code<sup>*</sup> </label>
                                         <label v-if="isEn==false">Code postal<sup>*</sup> </label>

                                        <div class="form-group__content">
                                            <input class="form-control" type="text" v-model="new_recipient.postal_code" required maxlength="30">
                                        </div>
                                    </div>

                            </div>


                            <br/> <br/>
                            <div class="form-group" v-if="showSaveCheckbox">
                                    <div class="ps-checkbox">
                                        <input type="checkbox" id="checkbox" v-model="checked">
                                        <label v-if="isEn==true" for="checkbox">Save recipient for future use</label>
                                        <label v-if="isEn==false" for="checkbox">Sauvegarder destinataire </label>
                                    </div>

                            </div>

                                    <h3 class="mt-40" v-if="isEn==true"> Addition information</h3>
                                    <h3 class="mt-40" v-if="isEn==false">Informations supplémentaires</h3>
                                  <div class="form-group">
                                    <label v-if="isEn==true">PO (Reference) </label>
                                    <label v-if="isEn==false">PO (Référence)</label>

                                    <div class="form-group__content">
                                      <input class="form-control" type="text" v-model="new_recipient.reference" required maxlength="255">
                                    </div>
                                  </div>
                                    <div class="form-group">
                                        <label></label>
                                        <div class="form-group__content">
                                            <textarea v-model="new_recipient.note" class="form-control" rows="4"  placeholder="Notes about your order, e.g. special notes for delivery."></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-5 col-lg-4 col-md-12 col-sm-12  ">
                                <div class="ps-form__total">
                                    <h3 v-if="isEn==true" class="ps-form__heading">Your Order</h3>
                                    <h3 v-if="isEn==false" class="ps-form__heading">Votre commande</h3>
                                    <div class="content">
                                        <div class="ps-block--checkout-total">
                                            <div class="ps-block__header">
                                                <p v-if="isEn==true">Products</p>
                                                <p v-if="isEn==false">Produits</p>
                                                <p></p>
                                            </div>
                                            <div class="ps-block__content">
                                                <table class="table ps-block__products">
                                                    <tbody>
                                                        <tr v-for="crt in cart" :key="crt.id">
                                                            <td><a href="#"> {{crt.description}}× {{crt.minimum_quantity}}</a>
                                                                <p><strong></strong></p>
                                                            </td>
                                                            <td></td>
                                                        </tr>

                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                        <a v-if="isEn==true" class="ps-btn ps-btn--fullwidth btn" :class="{ disabled: submitted}" :aria-disabled="submitted" role="button" @click="completeOrder()">Proceed to checkout</a>
                                        <a v-if="isEn==false" class="ps-btn ps-btn--fullwidth btn" :class="{ disabled: submitted}" :aria-disabled="submitted" role="button" @click="completeOrder()">Passer la commande</a>
                                    </div>
                                <div v-if="sent" class="loading">
                                 <div class="spinner-border" role="status">
                                 </div>
                                 <span class="visually-hidden">Loading...</span>
                               </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DataService from "@/services/DataService";
export default {
  name: 'Checkout',
  props: ['search_on','search_obj','language'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      picked:"newrecipient",
      existrecip : true,
      recipients:[],
      failed:false,
      isEn: true,
      sent: false,
      token:"",
      lang : this.language,
      cart :JSON.parse(localStorage.getItem('basket')),
      noRecord:false,
      checked:false,
      showSaveCheckbox: true,
      old_recipient:{
        full_name:"",phoneext: "",contact:"",address:"",email:"",company:"",address2:"",
      city:"",country:"CA",region:"",postal_code:"",note:"", reference: "", saverecip:false,products:[]
      },
      new_recipient:{full_name:"",phoneext: "",contact:"",address:"",email:"",company:"",address2:""
      ,city:"",country:"CA",region:"QC",postal_code:"",note:"",reference: "", saverecip:false,products:[]
      },
      init_recip :{full_name:"",phoneext: "",contact:"",address:"",email:"",company:"",address2:""
      ,city:"",country:"",region:"",postal_code:"",note:"",reference: "", saverecip:false,products:[]
      },
      selected_recip:{},
      countries:{},
      regions:{},
      submitted: false,
      // AMD-17 : longueurs acceptées par le service d'expédition. Les champs de
      // saisie sont limités par maxlength, mais un destinataire enregistré avant
      // cette correction peut dépasser ces longueurs : on l'annonce à la sélection.
      field_limits:{
        full_name:{max:32, en:'Full name', fr:'Nom complet'},
        company:{max:30, en:'Company', fr:'Compagnie'},
        address:{max:46, en:'Address', fr:'Adresse'},
        address2:{max:25, en:'Address 2', fr:'Adresse 2'},
        city:{max:30, en:'City', fr:'Ville'},
        postal_code:{max:30, en:'Postal code', fr:'Code postal'},
        phoneext:{max:20, en:'Phone extension', fr:'Numéro de poste'}
      }
    }
  },

    methods: {

    onChange() {


//console.log(this.old_recipient);

        if(this.selected_recip=={} || this.selected_recip==""){
           this.new_recipient = this.old_recipient;
           this.showSaveCheckbox = true;
        }else{
            this.new_recipient = this.selected_recip;
            this.checked = false;
            this.showSaveCheckbox = false;
            this.list_regions(this.new_recipient.country);
            this.warnAboutTooLongFields();
        }
    },

    /**
     * AMD-17 : prévient quand un destinataire enregistré contient un champ plus
     * long que ce que le service d'expédition accepte, plutôt que de laisser la
     * commande échouer au moment de la valider.
     */
    warnAboutTooLongFields(){

      var isEn = this.isEn;
      var tooLong = [];

      for (var field in this.field_limits){

        var limit = this.field_limits[field];
        var value = this.new_recipient[field];

        if(value && String(value).length > limit.max){
          tooLong.push((isEn ? limit.en : limit.fr) + ' (' + limit.max + ')');
        }
      }

      if(tooLong.length === 0){
        return;
      }

      this.msg = isEn
        ? 'This recipient must be corrected before ordering. Fields too long: ' + tooLong.join(', ') + '.'
        : 'Ce destinataire doit être corrigé avant de commander. Champs trop longs : ' + tooLong.join(', ') + '.';

      this.$parent.eventmsg = this.msg;
      this.$parent.showeventmsg = false;
      this.$parent.showerrormsg = true;
    },


    completeOrder(){
      this.sent = false;
      this.submitted = true
      this.new_recipient.saverecip = this.checked;
      this.new_recipient.products = this.cart;

      var token = localStorage.getItem('token');
      var dataa = this.new_recipient;
      this.sent = true;
      DataService.submitting_the_checkout(dataa,token)
          .then(response => {
            //console.log(response);
            this.sent = false;
            this.new_recipient = this.init_recip;
            this.cart=[]; localStorage.setItem('basket',""); this.$parent.cart=[];
            if(this.isEnglish()){
              this.msg = 'Order has Successfully been completed .';
            }else{
              this.msg = 'Votre commande a été enregistrée avec succès.';
            }

            this.$parent.eventmsg = this.msg;
            this.$parent.showerrormsg = false;
            this.$parent.showeventmsg = true;

            setTimeout(() => this.$parent.showeventmsg = false, 3000);

            this.$router.push('/orderComplete');

          })
          .catch(error => {
            //console.log(error.response.data.message);
            this.sent = false;
            this.submitted = false

            // AMD-17 : l'API renvoie un tableau de messages (champs trop longs,
            // produit en rupture...). On les affiche tous, et on garde un texte
            // de repli plutot qu'une alerte vide quand la reponse n'en contient pas.
            var data = (error.response && error.response.data) ? error.response.data : {};
            var messages = data.message || data.errors;

            if(Array.isArray(messages)){
              this.msg = messages.join(' ');
            }else if(messages){
              this.msg = messages;
            }else{
              this.msg = this.isEn
                ? 'The order could not be submitted. Please try again or contact Entrepro.'
                : "La commande n'a pas pu être transmise. Veuillez réessayer ou contacter Entrepro.";
            }

            this.$parent.eventmsg = this.msg;
            this.$parent.showeventmsg = false;

            this.$parent.showerrormsg = true;

            // Un message listant plusieurs champs demande plus de 3 secondes de lecture.
            setTimeout(() => this.$parent.showerrormsg = false, 8000);

          });
    },


    onCountrySelect(country){
     this.list_regions(country);
    },

    list_recipients(){

        this.noRecord = false;
        var token = localStorage.getItem('token');
        var dataa = {};
        DataService.get_recipients(dataa,token)
          .then(response => {
            this.recipients = response.data.recipients;
            if(this.recipients.length==0){
              this.msg = 'No recipients available ';
              this.noRecord = true;
            }

          })
          .catch(e => {
            //console.log(e.response);
            //this.message = error.response.data.errors[0];
          if(e!=undefined){

          if(e.response.status == 404){

            this.msg = "Route nod found";
          }else if(e.response.status == 401){
             this.$router.push('/login');
          }else if(e.response.status == 500){
            this.msg = "Sorry , service unavailable at the moment , try again later.";
          }else if(e.response.status == 422){
            this.msg = this.$parent.translate_error_message(e.response.data.errors,"errors");
          }else {
            this.msg = "Please check your internet.";
          }
          this.failed = true;

          }


          });
    },


    list_countries(){

        var token = localStorage.getItem('token');
        var dataa = {};
        DataService.get_countries(dataa,token)
          .then(response => {
            this.countries = response.data.countries;

          })
          .catch(error => {
            console.log(error.response);
            //this.message = error.response.data.errors[0];

          });
    },


    list_regions(country){

        var token = localStorage.getItem('token');
        var dataa = {country:country};
        DataService.get_regions(dataa,token)
          .then(response => {
            //console.log(response);
            this.regions = response.data.regions;

          })
          .catch(error => {
            console.log(error.response);
            //this.message = error.response.data.errors[0];

          });
    },

    isEnglish(){

            let lang = localStorage.getItem('lang');
            if(lang=='en'){

            return true;

            }else if(lang=='fr'){

            return false;

            }else{

            return true;

            }


      },

    },


    computed: {
      computed_postal_code: function () {

        return this.new_recipient.address + " " + this.new_recipient.address2 + " " +
        this.new_recipient.city + " " + this.new_recipient.country + " " +
        this.new_recipient.region;
      }
    },


    watch: {

      search_on:function(){
        //console.log("value of search_on is :"+this.search_on);

        if(this.search_on){

          //this.search_user_products(this.search_obj);
           //this.$parent.search_on = false;
           this.$router.push('/products');

        }

        //console.log(this.search_obj);
      },

      language:function(){
        this.lang = this.language;
        this.isEn = this.isEnglish();
        //console.log("language value has changed in [products] component");

      },

},

    created(){

     this.list_countries();
     this.list_regions('CA');
    },



    mounted(){

      this.isEn = this.isEnglish();
      if(localStorage.getItem('token')=='' || localStorage.getItem('token')==null){

        this.$router.push('/login');
      }else{

        /*if(localStorage.getItem('caller_role')=='Basic'){
          this.$router.push('/login');

        }else{*/

          this.$parent.token = localStorage.getItem('token');
          this.token = localStorage.getItem('token');
          this.list_recipients();

        //}

      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.custom-form {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Checkout.vue